import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../src/assets/global.css';
import axios from "axios";
import echarts from 'echarts'
import VueRouter from "vue-router";
import router from './router';
import store from './store';

Vue.prototype.$axios=axios;
Vue.prototype.$httpUrl='https://qsy.phw222.top';
// Vue.prototype.$httpUrl='http://localhost:8090';
// 添加全局事件总线
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueRouter);
new Vue({
  router,
  echarts,
  store,
  render: h => h(App),
}).$mount('#app')
